/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconInlineMiddleLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 20 20">
    <><path opacity="0.5" d="M 2,3 H 18 V 4.5 H 2 Z M 13.5,9.0169492 H 18 V 10.516949 H 13.5 V 9.7669492 Z M 2,15 h 16 v 1.5 H 2 Z" />
<path d="m 12.003,7 v 5.5 a 1,1 0 0 1 -1,1 H 2.996 a 1,1 0 0 1 -1,-1 V 7 a 1,1 0 0 1 1,-1 h 8.007 a 1,1 0 0 1 1,1 z M 10.497,7.5 H 3.5 V 12 h 6.997 z" /></>
  </Icon>
);
};

IconInlineMiddleLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyBjbGFzcz0iY2sgY2staWNvbiBjay1yZXNldF9hbGwtZXhjbHVkZWQgY2staWNvbl9pbmhlcml0LWNvbG9yIGNrLWJ1dHRvbl9faWNvbiIgdmlld0JveD0iMCAwIDIwIDIwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTSAyLDMgSCAxOCBWIDQuNSBIIDIgWiBNIDEzLjUsOS4wMTY5NDkyIEggMTggViAxMC41MTY5NDkgSCAxMy41IFYgOS43NjY5NDkyIFogTSAyLDE1IGggMTYgdiAxLjUgSCAyIFoiLz4KICA8cGF0aCBkPSJtIDEyLjAwMyw3IHYgNS41IGEgMSwxIDAgMCAxIC0xLDEgSCAyLjk5NiBhIDEsMSAwIDAgMSAtMSwtMSBWIDcgYSAxLDEgMCAwIDEgMSwtMSBoIDguMDA3IGEgMSwxIDAgMCAxIDEsMSB6IE0gMTAuNDk3LDcuNSBIIDMuNSBWIDEyIGggNi45OTcgeiIvPgo8L3N2Zz4=";
IconInlineMiddleLineComponent.Content = `<svg class="ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-button__icon" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.5" d="M 2,3 H 18 V 4.5 H 2 Z M 13.5,9.0169492 H 18 V 10.516949 H 13.5 V 9.7669492 Z M 2,15 h 16 v 1.5 H 2 Z"/>
  <path d="m 12.003,7 v 5.5 a 1,1 0 0 1 -1,1 H 2.996 a 1,1 0 0 1 -1,-1 V 7 a 1,1 0 0 1 1,-1 h 8.007 a 1,1 0 0 1 1,1 z M 10.497,7.5 H 3.5 V 12 h 6.997 z"/>
</svg>`;

const IconInlineMiddleLine = styled(IconInlineMiddleLineComponent)``;

export default IconInlineMiddleLine;
